import $ from 'jquery';
import getYoutubeId from '../util/getYoutubeId';

/**
 * @description
 * Abre um modal utilizando bootstrap e pega a url do vídeo do youtube a partir da propriedade data-src.
 * Altera a propriedade src do iframe dentro do modal adicionando autoplay a url para que o vídeo inicie automaticamente
 */

const ModalVideo = {
  init: (config = {onInitiated: null, onOpen: null, onClose: null}) => {
    const {onInitiated, onOpen, onClose} = config
    if(onInitiated) onInitiated();

    $('.js-open-modal-video').on('click', event => {
      if(onOpen) onOpen();

      const target = $(event.currentTarget);
      const theModal = target.data('target');
      const videoSRC = target.attr('data-src');
      const videoId = getYoutubeId(videoSRC);
      const videoSRCauto = `//www.youtube.com/embed/${videoId}?modestbranding=1&rel=0&controls=1&showinfo=0&html5=1&autoplay=1`;

      $(`${theModal} iframe`).attr('src', videoSRCauto);
      $(theModal).on('hide.bs.modal', () => {
        $(`${theModal} iframe`).attr('src', '');
        if(onClose) onClose();
      });
    });
  },
};

export default ModalVideo;
